import { useMemo } from "react";

// Third party
import { v4 as uuidv4 } from "uuid";

// Material
import { Skeleton, Grid, Card, Stack } from "@mui/material";

// Components
import { UserProfilePicture } from "@/Layouts/components/UserProfilePicture";

type CommissionCycleClosingReviewersLoaderProps = {
	cardsLength: number;
};

export default function CommissionCycleClosingReviewersLoader(props: Readonly<CommissionCycleClosingReviewersLoaderProps>) {
	const { cardsLength } = props;

	const memoizedCards = useMemo(() => {
		if (cardsLength <= 0) {
			return null;
		}
		return (
			<Grid
				container
				direction="row"
				justifyContent="space-between"
				rowGap={6}
				columnSpacing={7}
				paddingRight={2}
				paddingLeft={8}
				paddingTop={1}
				marginTop={5}
				marginBottom={4}
				position={"relative"}
				maxHeight={"480px"}
				overflow={"auto"}
			>
				{Array.from({ length: cardsLength }).map((_) => (
					<Grid item key={`card-loading-${uuidv4()}`} alignItems={"center"} xs={4}>
						<UserProfilePicture
							src={"Holder"}
							iconClasses="text-neutral-gray fill-neutral-gray"
							className={"!w-[80px] !h-[80px] border-[2.5px] ml-[-20px] !bg-white !absolute border-neutral-gray"}
						/>
						<Card className="!shadow-[0px_4px_8px_0px] !shadow-shadow-gray !rounded-[6px] w-[300px]">
							<Stack display={"flex"} direction={"column"} py={"9px"} pl={"70px"} spacing={"8px"}>
								<Skeleton className="rounded-sm w-[160px] !h-[16px]" variant="rectangular" />
								<Skeleton className="rounded-sm w-[80px] !h-[10px]" variant="rectangular" />
								<Skeleton className="rounded-sm w-[120px] !h-[14px]" variant="rectangular" />
							</Stack>
						</Card>
					</Grid>
				))}
			</Grid>
		);
	}, [cardsLength]);

	return <>{memoizedCards}</>;
}
